import { Params } from '@angular/router';

export class HisSearchPrintviewData {

    pageTitle: string;

    searchConfigFile: string;
    
    showSearchInfo: boolean;
    
    queryParams: Params;
        
    searchResultSize: number;
    
}
